import React from 'react';
import * as Icons from 'lucide-react';
import { heroHighlights } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function ServiceHighlights() {
  const { t } = useLang();
  return (
    <section className="relative -mt-28 md:-mt-32 z-10">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {heroHighlights.map((h, idx) => {
            const Icon = Icons[h.icon] || Icons.Sparkles;
            const isBrown = idx === 1;
            return (
              <div
                key={h.id}
                className={`group relative rounded-xl p-7 transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                  isBrown
                    ? 'bg-[#4a2e1a] text-white shadow-[0_20px_45px_-20px_rgba(74,46,26,0.6)]'
                    : 'bg-white text-[#14110f] shadow-[0_20px_45px_-20px_rgba(20,17,15,0.18)] hover:bg-[#4a2e1a] hover:text-white'
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-lg bg-[#f5b300] flex items-center justify-center shrink-0">
                    <Icon className="w-7 h-7 text-[#14110f]" strokeWidth={1.8} />
                  </div>
                  <div>
                    <h3 className={`text-[18px] font-bold mb-1.5 transition-colors ${isBrown ? 'text-white' : 'group-hover:text-white'}`}>
                      {t(h.titleKey)}
                    </h3>
                    <p className={`text-[13.5px] leading-relaxed ${isBrown ? 'text-white/75' : 'text-neutral-500 group-hover:text-white/75'}`}>
                      {t(h.textKey)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
